import { ReactNode } from "react";

export default function Date({ children }: { children: ReactNode }) {
  return (
    <p className="font-primary font-medium text-gray-800 text-xs">{children}</p>
  );
}
